const ErrorText = (props) => {
    return <span className={`text-danger fs-12 fw-500 ${props.className ? props.className : 'mt-3'}`}>{props.children}</span>;
};

export default ErrorText;